import { render, staticRenderFns } from "./OrderRefundDetail.vue?vue&type=template&id=00ca27ee&"
import script from "./OrderRefundDetail.vue?vue&type=script&lang=js&"
export * from "./OrderRefundDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderRefundDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports